define('home/views/FetchingView',[
    'backbone-marionette',
], function (
    Marionette
) {
    'use strict';

    var FetchingView = Marionette.ItemView.extend({
        className: 'spinner',
        template: function () {},
        initialize: function (options) {
            Marionette.ItemView.prototype.initialize.call(this, options);

            options = options || {};
            if (options.className)
                this.className = options.className;
        },
    });

    return FetchingView;
});

